import { Component, inject } from "@angular/core";

import { JslibModule } from "@vowkey/angular/jslib.module";
import { PlatformUtilsService } from "@vowkey/common/platform/abstractions/platform-utils.service";
import { LinkModule, PopoverModule } from "@vowkey/components";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "vault-permit-cipher-details-popover",
  templateUrl: "./permit-cipher-details-popover.component.html",
  imports: [PopoverModule, JslibModule, LinkModule],
})
export class PermitCipherDetailsPopoverComponent {
  private platformUtilService = inject(PlatformUtilsService);

  openLearnMore(e: Event) {
    e.preventDefault();
    this.platformUtilService.launchUri("https://vowkey.com/help/website-icons/");
  }
}
